// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Messages_wrap_3z9cA","modal":"Messages_modal_4VCFr","btn":"Messages_btn_2euov","primary":"Messages_primary_30oH3","disabled":"Messages_disabled_3oVp6"};